import ProfileSidebar from '@components/sidebars/profile-sidebar/profile-sidebar';
export default ProfileSidebar;
